import fetchWrapper, {postWrapper} from "../utils/fetchWrapper";

export class userPermissionsService {
  checkUserPermissions = async function (programId, requestedPermissions) {
    let path = `/api/UserPermission`;
    const payload = {
      programId:programId,
      requestedPermissions
    };

    try {
      const data = await postWrapper({url:path,data:payload});
      return data;
    } catch (e) {
      console.log(`check permissions: ${e}`);
      throw e;
    }
  };

  getCurrentPosition = async function (programId) {
    let path = `/api/currentPosition/${programId}`;
    try {
      const data = await fetchWrapper({url:path});
      return data;
    } catch (e) {
      console.log(`get current position: ${e}`);
      return null;
    }

  }
}

export default userPermissionsService;
